import { FC, ReactNode, useMemo } from 'react';
import { MentionsInput, Mention } from 'react-mentions';

export type TagSpanProps = {
  children: ReactNode;
  tagName: string;
  isValid: boolean;
};

export const TagSpan: FC<TagSpanProps> = ({
  children,
  tagName,
  isValid,
}) => (
  <span
    style={{
      background: isValid ? '#e0f7fa' : '#ffebee',
      color: isValid ? '#00796b' : '#c62828',
      borderRadius: '4px',
      padding: '0 4px',
      fontWeight: 500,
      border: isValid ? 'none' : '1px solid #ef5350',
    }}
    title={
      isValid ? `Valid tag: ${tagName}` : `Invalid tag: ${tagName}`
    }
  >
    {children}
  </span>
);

export interface TagEditorProps {
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  disabled?: boolean;
  placeholder?: string;
  tagRegex?: RegExp;
  validTags?: string[];
}

export const TagEditor: FC<TagEditorProps> = ({
  value,
  placeholder,
  validTags,
  disabled,
  onChange,
  onBlur,
}) => {
  // Convert validTags to react-mentions format
  const mentions = useMemo(() => {
    if (!validTags || !Array.isArray(validTags)) {
      console.log('TagInput: No valid tags provided or not an array');
      return [];
    }

    const filtered = validTags.filter(
      tag => tag && typeof tag === 'string',
    );
    console.log('TagInput: Filtered suggestions', filtered);

    return filtered.map(tag => ({
      id: tag,
      display: tag,
    }));
  }, [validTags]);

  return (
    <MentionsInput
      value={value}
      onChange={onChange as any}
      onBlur={onBlur}
      placeholder={placeholder}
      style={inputStyles}
      disabled={disabled}
    >
      <Mention trigger="@" data={mentions} style={mentionStyles} />
    </MentionsInput>
  );
};

export const inputStyles = {
  control: {
    backgroundColor: '#fff',
    lineHeight: 'normal',
    fontSize: 16,
    fontWeight: 'normal' as const,
    border: '1px solid #ccc',
    // borderRadius: 4,
    minHeight: 80,
    padding: '8px 12px',
    color: '#000',
  },
  input: {
    color: '#000',
    padding: '8px 12px',
  },
  '&multiLine': {
    control: {
      minHeight: 80,
    },
    input: {
      color: '#000',
    },
  },
  suggestions: {
    list: {
      backgroundColor: 'white',
      border: '1px solid #ccc',
      borderRadius: 4,
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      fontSize: 14,
      lineHeight: 'normal',
      maxHeight: 200,
      overflow: 'auto' as const,
      zIndex: 9999,
    },
    item: {
      padding: '8px 12px',
      zIndex: 2000,
      borderBottom: '1px solid #f0f0f0',
      color: '#000',
      '&focused': {
        backgroundColor: '#e3f2fd',
      },
    },
  },
} as const;

export const mentionStyles = {
  backgroundColor: '#e0f7fa',
  color: '#00796b',
  borderRadius: '4px',
  // padding: "0 4px",
  fontWeight: 'normal',
  display: 'inline',
  verticalAlign: 'baseline',
  lineHeight: 'normal',
  fontSize: '16px',
  position: 'relative',
  top: -2,
  left: -1,
  zIndex: 1000,
} as const;
